// IMPORTANT: THIS FILE IS AUTO GENERATED AND OVERWRITTEN ON BUILD!
/* tslint:disable */
export const GITVERSION = {
  "dirty": false,
  "raw": "a5a0f52",
  "hash": "a5a0f52",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "a5a0f52",
  "semverString": null
};
export const DATESTAMP = '2025-07-07 13:11:06';
/* tslint:enable */
